// unwrapItems — normalize an RPC response to its ITEMS ARRAY.
//
// Several backend RPCs return either an `{ items, pagination }` envelope or a bare
// array as `data`; consumers that want the row list need to tolerate both. This is
// the canonical form of that unwrap, extracted from GoogleAnalyticsPage (where it
// lived as a local `unwrapItems` that the GA4 sub-tabs then re-inlined).
//
//   { data: { items: [...] } }  → [...]      (envelope)
//   { data: [...] }             → [...]      (bare-array data)
//   missing / null              → []         (safe default for `.map`/`.length`)
//
// SCOPE: this is for the "give me the rows" intent ONLY. It is NOT for responses
// whose `data` is a single object payload (KPIs, summary, filters) — those want the
// object itself and use `resp?.data ?? null`, a deliberately different contract.
// Don't route object-payload sites through here; `{...}.items` would be undefined
// and you'd silently get `[]`.
export const unwrapItems = (resp) => resp?.data?.items ?? resp?.data ?? [];

export default unwrapItems;
